import * as Sentry from '@sentry/browser';
import type { Middleware } from '@reduxjs/toolkit';
import type { State } from 'src/state';
import { payloadToData } from './payloadToData';

// Cache this state whenever possible, so that we don't need to retrieve it on before send.
// This way, the cache is accessible in reducer crashes.
let reduxState: State | null = null;

export const sentryForRedux: Middleware = (store) => (next) => (action) => {
  // Validate action type.
  if (!action || typeof action !== 'object') {
    return next(action);
  }
  if (!('type' in action) || !('payload' in action)) {
    return next(action);
  }
  if (typeof action.type !== 'string') {
    return next(action);
  }

  const actionsToIgnore = [
    'user/update', // This sets the whole state after every replicant action.
    'friends/updateFriendsStatesSuccess', // This sets all friends' states on every heartbeat.
  ];

  const payload = actionsToIgnore.includes(action.type)
    ? undefined
    : payloadToData(action.payload);

  Sentry.addBreadcrumb({
    category: 'redux-action',
    message: action.type,
    level: 'info',
    data: payload,
  });

  reduxState = store.getState();

  return next(action);
};

/**
 * Get the cached redux state.
 */
export function getReduxState() {
  return reduxState;
}
